export const KEEP_ALIVE_SUCCESS = 'KEEP_ALIVE_SUCCESS';
export const KEEP_ALIVE_FAILED = 'KEEP_ALIVE_FAILED';

export interface KeepAliveStore {
  reminderInSeconds?: number;
  sessionExpiration?: string;
  err?: unknown;
}
